import http from 'plugins/axios';

export default {
  getAllCoin() {
    return http.get({
      url: '/la/admin/coin/all'
    });
  },
  getColdList() {
    return http.get({
      url: '/la/admin/toCold/allToColdThreshold'
    });
  },
  getColdFee() {
    return http.get({
      url: '/la/admin/toCold/allToColdFee'
    });
  },
  addCold(data) {
    return http.post({
      url: '/la/admin/toCold/setToColdThreshold',
      data,
      dataType: 'form'
    });
  },
  deteleCold(data) {
    return http.post({
      url: '/la/admin/toCold/delToColdThreshold',
      data,
      dataType: 'form'
    });
  },
  editFee(data) {
    return http.post({
      url: '/la/admin/toCold/setToColdFee',
      data,
      dataType: 'form'
    });
  }
};
